import { createPopper as w } from "@popperjs/core";
import { LitElement as S, unsafeCSS as c } from "lit";
import { query as v, property as r, state as _ } from "lit/decorators.js";
import T from "../../shared/reset.style.css.js";
import { booleanType as l, booleanConverter as d } from "../../utils/property-types.js";
import V from "../form-input/form-input.style.css.js";
import k from "./form-datepicker.style.css.js";
import { template as O } from "./form-datepicker.template.js";
var F = Object.defineProperty, s = (f, t, e, a) => {
  for (var n = void 0, o = f.length - 1, h; o >= 0; o--)
    (h = f[o]) && (n = h(t, e, n) || n);
  return n && F(t, e, n), n;
};
const m = class m extends S {
  constructor() {
    super(), this.label = "", this.hideLabel = !1, this.name = "", this.id = "", this.type = "text", this.placeholder = "", this.value = "", this.disabled = !1, this.readonly = !1, this.required = !1, this.invalid = !1, this.autocapitalize = "none", this.autocomplete = "off", this.autocorrect = !1, this.autofocus = !1, this.spellcheck = !1, this.size = "lg", this.icon = "calendar_today", this.showCalendar = !1, this.dropdownPlacement = "bottom-start", this.dropdownFixed = !1, this.showTime = !1, this.showButtons = !1, this.leftLabel = "Cancel·lar", this.rightLabel = "Seleccionar", this.minDate = "", this.maxDate = "", this.timepicker = "", this.timepickerLabel = "Selecciona una hora", this.minHour = 0, this.maxHour = 24, this.minutesRange = 1, this.customCalendar = void 0, this.customTimeListOptions = [], this.validate = !1, this.errorMessageFormat = "El format de la data no és correcte.", this.errorMessageMinDate = "La data és anterior a la permesa.", this.errorMessageMaxDate = "La data és posterior a la permesa.", this.tooltipFixed = !1, this.forceViewport = !1, this.hasStepper = !1, this._defaultId = `dss-datepicker-${crypto.randomUUID()}`, this._isFocused = !1, this._isTruncated = !1, this._externalPlaceholder = "", this._previousDate = "", this._inputValidity = !0, this._popperInstance = null, this._placeholder = "", this._helpText = "", this._helpTextBackup = "", this._oldHelpText = "", this._isFirstUpdated = !0, this.internals = this.attachInternals(), this._handleClickOut = this._handleClickOut.bind(this), this._handleFocusOut = this._handleFocusOut.bind(this);
  }
  static get styles() {
    return [c(T), c(V), c(k)];
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._removeCalendarListener();
  }
  _addCalendarListener() {
    document.addEventListener("mousedown", this._handleClickOut), this.addEventListener("focusout", this._handleFocusOut);
  }
  _removeCalendarListener() {
    document.removeEventListener("mousedown", this._handleClickOut), this.removeEventListener("focusout", this._handleFocusOut);
  }
  _handleClickOut(t) {
    this._checkClickOutside(t);
  }
  _handleFocusOut(t) {
    this._checkFocusOut(t);
  }
  _getEffectiveId() {
    return this.id !== "" ? this.id : this._defaultId;
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this._helpTextBackup = this.helpText ?? "", this._createPopperCalendar(), this._input.classList.add("dss-input-skip-native"), this.requestUpdate();
    } catch {
      console.error("ERROR OCURRED");
    }
  }
  updated(t) {
    t.has("value") && this.internals.setFormValue(this.value), t.has("placeholder") && (this._placeholder = this.placeholder, this._externalPlaceholder = this.placeholder), t.has("showTime") && this.showTime && (this.showButtons = !0), t.has("helpText") && queueMicrotask(() => {
      this._helpText = this.helpText ?? "", this._oldHelpText = this.helpText ?? "";
    });
  }
  formDisabledCallback(t) {
    this.disabled = t;
  }
  formResetCallback() {
    this.value = "", this._input.value = "";
  }
  formStateRestoreCallback(t) {
    this.value = t ?? "", this._input.value = t ?? "";
  }
  render() {
    return O(this);
  }
  /* Handle Input Events */
  _handleInput(t) {
    var a;
    const e = (a = t.target.value) == null ? void 0 : a.replace(/\D/g, "");
    this._input && (this._input.value = this._formatDate(e), this.value = this._formatDate(e), this._handleValidity()), this._dispatchValueChange(), this.requestUpdate();
  }
  _handleFocusin() {
    var t;
    this._isFocused || this.readonly || (this._externalPlaceholder !== "" ? this._placeholder = this._externalPlaceholder : this._placeholder = this.showTime ? "DD/MM/AAAA HH:MM" : "DD/MM/AAAA", (t = this._input) == null || t.setAttribute("placeholder", this._placeholder), this.showCalendar = !0, this._popperInstance.update(), this._addCalendarListener(), this._isFocused = !0);
  }
  _focusInput() {
    var t;
    !this.disabled && !this.readonly && ((t = this._input) == null || t.focus());
  }
  _handleKeydown(t) {
    var e, a, n, o, h;
    if ((t == null ? void 0 : t.key) === "Tab" ? (this._isFocused = !0, this._checkInputOverflow()) : (t == null ? void 0 : t.key) === "Enter" || (t == null ? void 0 : t.key) === " " ? (this.showCalendar = !0, this._popperInstance.update(), this._checkInputOverflow(), this._addCalendarListener()) : (t == null ? void 0 : t.key) === "Escape" && this._closeCalendar(), t.key === "Enter" && this._input && ((e = this._input.value) == null ? void 0 : e.length) > 7 && this._input) {
      const u = (a = this._input.value) == null ? void 0 : a.replace(/(\d+[/])(\d+[/])/, "$2$1"), p = new Date(u), g = (n = p.getDate()) == null ? void 0 : n.toString().padStart(2, "0"), D = (p.getMonth() + 1).toString().padStart(2, "0"), b = p.getFullYear(), C = (o = p.getHours()) == null ? void 0 : o.toString().padStart(2, "0"), x = (h = p.getMinutes()) == null ? void 0 : h.toString().padStart(2, "0");
      let y = `${g}/${D}/${b}`;
      this.showTime && (y += ` ${C}:${x}`, this._handleValidity()), this._input && (this._input.value = y), this._dispatchValueChange(), this.showCalendar ? this._closeCalendar() : this.requestUpdate();
    }
  }
  _emitInput() {
    this.dispatchEvent(new Event("input", { bubbles: !0, composed: !0 }));
  }
  _emitChange() {
    this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }));
  }
  _checkInputOverflow() {
    if (!this._input || !this._input.value) return;
    const t = window.getComputedStyle(this._input), e = `${t.fontWeight} ${t.fontSize} ${t.fontFamily}`, n = document.createElement("canvas").getContext("2d");
    if (!n) return;
    n.font = e;
    const o = n.measureText(this._input.value).width;
    this._isTruncated = o > this._input.offsetWidth;
  }
  /* Hamdle Datepicker Validations */
  _handleValidity() {
    var e;
    const t = (e = this._input) == null ? void 0 : e.checkValidity();
    t !== void 0 && (this._inputValidity = t), this.internals.setValidity(this._input.validity, this._input.validationMessage, this._input);
  }
  _validateDate() {
    var e;
    const t = this._checkDateFormat((e = this._input) == null ? void 0 : e.value);
    t ? (this._input.setCustomValidity(this._helpText), this.internals.setValidity({ customError: !0 }, this._helpText, this._input)) : (this._input.setCustomValidity(""), this.internals.setValidity({})), this._dispatchOnValidate(t);
  }
  _checkDateFormat(t) {
    const e = this.showTime ? 16 : 10;
    if (t === "")
      return this._helpText = this._helpTextBackup, this.invalid = !1, !1;
    if (t.length < e)
      return this._helpText = this.errorMessageFormat, this.invalid = !0, !0;
    if (this.minDate || this.maxDate) {
      const a = this.showTime ? t.substring(0, 10) : t, n = new Date(this._convertToISO(a)), o = new Date(this._convertToISO(this.minDate)), h = new Date(this._convertToISO(this.maxDate));
      if (o && n < o)
        return this._helpText = this.errorMessageMinDate, this.invalid = !0, !0;
      if (h && n > h)
        return this._helpText = this.errorMessageMaxDate, this.invalid = !0, !0;
    }
    return this._helpText = this._helpTextBackup, this.invalid = !1, !1;
  }
  _convertToISO(t) {
    const [e, a, n] = t.split("/");
    return `${n}-${a}-${e}`;
  }
  _dispatchOnValidate(t) {
    var a;
    const e = {
      detail: {
        date: (a = this._input) == null ? void 0 : a.value,
        invalid: t,
        status: this.invalid ? "INVALID" : "VALID"
      },
      bubbles: !1,
      composed: !1
    };
    this.dispatchEvent(new CustomEvent("value-changed", e));
  }
  // Datepicker specific methods
  _formatDate(t) {
    let e = t.substring(0, 2), a = t.substring(2, 4);
    const n = t.substring(4, 8);
    let o = t.substring(8, 10), h = t.substring(10, 12);
    Number(e) > 3 && (e = e == null ? void 0 : e.padStart(2, "0")), Number(a) > 1 && (a = a == null ? void 0 : a.padStart(2, "0")), Number(e) > 31 && (e = "31"), Number(a) > 12 && (a = "12"), a === "02" && Number(e) > 28 && (n == null ? void 0 : n.length) === 4 && (e = new Date(Number(n), 1, 29).getMonth() === 1 ? "29" : "28");
    let u = `${e}${a ? `/${a}` : ""}${n ? `/${n}` : ""}`;
    return this.showTime && (Number(o) > 2 && (o = o == null ? void 0 : o.padStart(2, "0")), Number(o) > 23 && (o = "23"), Number(h) > 5 && (h = h == null ? void 0 : h.padStart(2, "0")), u = `${u}${o ? ` ${o}` : ""}${h ? `:${h}` : ""}`), u;
  }
  _onDateChange(t) {
    const e = t.detail;
    this._input && (this._input.value = e, this.value = e, this._handleValidity()), this._closeCalendar(), this._dispatchValueChange();
  }
  _onCancel() {
    this._closeCalendar(), this._input && (this._input.value = this._previousDate || "", this._handleValidity()), this.requestUpdate();
  }
  _dispatchValueChange() {
    this._emitInput(), this._emitChange();
  }
  _clearDate() {
    this._input && (this._input.value = "", this._input.setCustomValidity(""), this.internals.setValidity({}), this.value = "", this._handleValidity(), this._helpText = this._helpTextBackup, this.invalid = this._input ? !this._input.checkValidity() : !1, this._dispatchValueChange(), this.requestUpdate());
  }
  /* Handle Popper */
  _createPopperCalendar() {
    var a, n;
    const t = (a = this.shadowRoot) == null ? void 0 : a.querySelector(".dss-input-group"), e = (n = this.shadowRoot) == null ? void 0 : n.querySelector(".dss-calendar");
    t && e && (this._popperInstance = w(t, e, {
      placement: this.dropdownPlacement,
      strategy: this.dropdownFixed ? "fixed" : "absolute",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 4]
          }
        },
        {
          name: "preventOverflow",
          options: {
            padding: { top: 8, bottom: 8, left: 16, right: 16 }
          }
        }
      ]
    }));
  }
  _closeCalendar() {
    var t, e;
    this._removeCalendarListener(), (t = this._input) == null || t.removeAttribute("placeholder"), this._placeholder = "", this._isFocused = !1, this.showCalendar = !1, (e = this._input) == null || e.blur(), this.validate && this._validateDate(), this._checkInputOverflow(), this.requestUpdate();
  }
  _checkClickOutside(t) {
    t.composedPath().includes(this) || this.showCalendar && this._closeCalendar();
  }
  _checkFocusOut(t) {
    const e = t.relatedTarget;
    e !== null && e !== this && e !== this._input && e !== this._label && this.showCalendar && this._closeCalendar();
  }
  _prevDate() {
    var n;
    if (!this._input) return;
    const t = (n = this._input) == null ? void 0 : n.value, e = this._currentValueToDate(t || "");
    e.setDate(e.getDate() - 1);
    const a = this._newDateToValue(e);
    this._input.value = a, this.value = a, this._handleValidity(), this._dispatchValueChange(), this._checkInputOverflow(), this.requestUpdate();
  }
  _nextDate() {
    var n;
    if (!this._input) return;
    const t = (n = this._input) == null ? void 0 : n.value, e = this._currentValueToDate(t || "");
    e.setDate(e.getDate() + 1);
    const a = this._newDateToValue(e);
    this._input.value = a, this.value = a, this._handleValidity(), this._dispatchValueChange(), this._checkInputOverflow(), this.requestUpdate();
  }
  _currentValueToDate(t) {
    const e = t == null ? void 0 : t.split(" ")[0].split("/"), a = Number.parseInt(e ? e[0] : "0", 10), n = Number.parseInt(e ? e[1] : "0", 10) - 1, o = Number.parseInt(e ? e[2] : "0", 10), h = new Date(o, n, a);
    return new Date(h);
  }
  _newDateToValue(t) {
    const e = t.getDate().toString().padStart(2, "0"), a = (t.getMonth() + 1).toString().padStart(2, "0"), n = t.getFullYear();
    return `${e}/${a}/${n}`;
  }
  _isPrevDateDisabled() {
    var a;
    const t = this._getDateFromValue(this.value || ((a = this._input) == null ? void 0 : a.value)), e = this._getDateFromValue(this.minDate);
    return !t || !e ? !1 : t <= e;
  }
  _isNextDateDisabled() {
    var a;
    const t = this._getDateFromValue(this.value || ((a = this._input) == null ? void 0 : a.value)), e = this._getDateFromValue(this.maxDate);
    return !t || !e ? !1 : t >= e;
  }
  _getDateFromValue(t) {
    if (!t) return null;
    const a = (this.showTime ? t.substring(0, 10) : t).split("/");
    if (a.length !== 3) return null;
    const [n, o, h] = a;
    if (!n || !o || !h) return null;
    const u = this._convertToISO(`${n}/${o}/${h}`), p = new Date(u);
    return Number.isNaN(p.getTime()) ? null : p;
  }
  isValidDate() {
    var h;
    if (!this._input) return !1;
    const t = (h = this._input.value) == null ? void 0 : h.split(" ")[0].split("/");
    if (!t || t.length !== 3) return !1;
    const e = Number.parseInt(t[0], 10), a = Number.parseInt(t[1], 10) - 1, n = Number.parseInt(t[2], 10), o = new Date(n, a, e);
    return !Number.isNaN(o.getTime());
  }
  focus(t) {
    if (this._input) {
      this._input.focus(t);
      return;
    }
    this.updateComplete.then(() => {
      var e;
      (e = this._input) == null || e.focus(t);
    });
  }
};
m.formAssociated = !0;
let i = m;
s([
  v("input.dss-input")
], i.prototype, "_input");
s([
  v("label.dss-label")
], i.prototype, "_label");
s([
  r({ type: String })
], i.prototype, "label");
s([
  r(l)
], i.prototype, "hideLabel");
s([
  r({ type: String })
], i.prototype, "name");
s([
  r({ type: String })
], i.prototype, "id");
s([
  r({ type: String })
], i.prototype, "type");
s([
  r({ type: String })
], i.prototype, "placeholder");
s([
  r({ type: String })
], i.prototype, "value");
s([
  r({ converter: d, reflect: !0 })
], i.prototype, "disabled");
s([
  r({ converter: d, reflect: !0 })
], i.prototype, "readonly");
s([
  r({ converter: d, reflect: !0 })
], i.prototype, "required");
s([
  r({ converter: d, reflect: !0 })
], i.prototype, "invalid");
s([
  r({ type: Number })
], i.prototype, "step");
s([
  r({ type: Number })
], i.prototype, "min");
s([
  r({ type: Number })
], i.prototype, "max");
s([
  r({ type: Number })
], i.prototype, "minLength");
s([
  r({ type: String })
], i.prototype, "pattern");
s([
  r({ type: String })
], i.prototype, "inputmode");
s([
  r({ type: String })
], i.prototype, "autocapitalize");
s([
  r({ type: String })
], i.prototype, "autocomplete");
s([
  r(l)
], i.prototype, "autocorrect");
s([
  r(l)
], i.prototype, "autofocus");
s([
  r(l)
], i.prototype, "spellcheck");
s([
  r({ type: String })
], i.prototype, "size");
s([
  r({ type: String })
], i.prototype, "icon");
s([
  r({ type: String })
], i.prototype, "helpText");
s([
  r(l)
], i.prototype, "showCalendar");
s([
  r({ type: String })
], i.prototype, "dropdownPlacement");
s([
  r(l)
], i.prototype, "dropdownFixed");
s([
  r(l)
], i.prototype, "showTime");
s([
  r(l)
], i.prototype, "showButtons");
s([
  r({ type: String })
], i.prototype, "leftLabel");
s([
  r({ type: String })
], i.prototype, "rightLabel");
s([
  r({ type: String })
], i.prototype, "minDate");
s([
  r({ type: String })
], i.prototype, "maxDate");
s([
  r({ type: String })
], i.prototype, "timepicker");
s([
  r({ type: String })
], i.prototype, "timepickerLabel");
s([
  r({ type: Number })
], i.prototype, "minHour");
s([
  r({ type: Number })
], i.prototype, "maxHour");
s([
  r({ type: Number })
], i.prototype, "minutesRange");
s([
  r({ type: Array })
], i.prototype, "customCalendar");
s([
  r({ type: Array })
], i.prototype, "customTimeListOptions");
s([
  r(l)
], i.prototype, "validate");
s([
  r(l)
], i.prototype, "errorMessageFormat");
s([
  r(l)
], i.prototype, "errorMessageMinDate");
s([
  r(l)
], i.prototype, "errorMessageMaxDate");
s([
  r(l)
], i.prototype, "tooltipFixed");
s([
  r(l)
], i.prototype, "forceViewport");
s([
  r(l)
], i.prototype, "hasStepper");
s([
  _()
], i.prototype, "_isFocused");
s([
  _()
], i.prototype, "_isTruncated");
s([
  _()
], i.prototype, "_helpText");
export {
  i as FormDatepicker
};
//# sourceMappingURL=form-datepicker.js.map
